import React from "react";
import { WizardStepProps } from "./types";
import WizardStepHeader from "./WizardStepHeader";

const WizardStep: React.FC<WizardStepProps> = ({
  children,
  stepNumber,
  stepCurrent,
  stepTitle,
}) => {
  if (stepCurrent !== stepNumber) return null;

  return (
    <div className="flex flex-col h-full">
      {stepTitle && (
        <WizardStepHeader stepNumber={stepNumber + 1} title={stepTitle} />
      )}

      <div className="h-full overflow-y-auto">{children}</div>
    </div>
  );
};

export default WizardStep;
